export const EngMessageConstant = {
  LoginSuccessfully: 'Login Successfully.',

  ResetPasswordSuccessfully: 'Reset Password Successfully.',

  UpdateAccountSuccessfully: 'Updated Account Successfully.',

  SentEmailConfirmationSuccessfully: 'Sent Email Confirmation Successfully.',
  ConfirmedOTPCodeSuccessfully: 'Confirmed OTP Code Successfully.',

  CreatedNewKitchenCenterSuccessfully: 'Created New Kitchen Center Successfully.',
  UpdatedKitchenCenterSuccessfully: 'Updated Kitchen Center Information Successfully.',
  UpdatedKitchenCenterStatusSuccessfully: 'Updated Kitchen Center Status Successfully.',
  DeletedKitchenCenterSuccessfully: 'Deleted Kitchen Center Successfully.',

  CreatedNewBrandSuccessfully: 'Created New Brand Successfully.',
  UpdatedBrandSuccessfully: 'Updated Brand Successfully.',
  UpdatedBrandStatusSuccessfully: 'Updated Brand Status Successfully.',
  UpdatedBrandProfileSuccessfully: 'Updated Brand Profile Successfully.',
  DeletedBrandSuccessfully: 'Deleted brand successfully.',

  UpdatedStoreStatusSuccessfully: 'Updated Store Status Successfully.',
  UpdatedStoreInformationSuccessfully: 'Updated Store Information Successfully.',
  DeletedStoreSuccessfully: 'Deleted Store Successfully.',
  RegisteredNewStoreSuccessfully: 'Registered New Store Successfully.',
  ConfirmedStoreRegistrationSuccessfully: 'Confirmed Store Registration Successfully.',

  CreatedNewCategorySuccessfully: 'Created New Category Successfully.',
  UpdatedCategorySuccessfully: 'Updated Category Successfully.',
  DeletedCategorySuccessfully: 'Deleted Category Successfully.',
  CreatedExtraCategoriesToNormalCategorySuccessfully: 'Create Extra-Categories To Normal Category Successfully.',

  CreatedNewBankingAccountSuccessfully: 'Created New Banking Account Successfully.',
  DeletedBankingAccountSuccessfully: 'Deleted Banking Account Successfully.',
  UpdatedStatusBankingAccountSuccessfully: 'Updated Banking Account Status Successfully.',
  UpdatedBankingAccountSuccessfully: 'Updated Banking Account Information Successfully.',

  CreatedNewProductSuccessfully: 'Created New Product Successfully.',
  UpdatedProductSuccessfully: 'Updated Product Successfully.',
  UpdatedProductStatusSuccessfully: 'Updated Product Status Successfully.',
  DeletedProductSuccessfully: 'Deleted Product Successfully.',

  CreatedPartnerSuccessfully: 'Created New Partner Successfully.',
  UpdatedPartnerSuccessfully: 'Updated Partner Information Successfully.',
  UpdatedPartnerStatusSuccessfully: 'Updated Partner Status Successfully.',
  DeletedPartnerSuccessfully: 'Deleted Partner Successfully.',

  CreatedNewStorePartnerSuccessfully: 'Created New Store Partner Successfully.',
  DeletedStorePartnerSuccessfully: 'Deleted Store Partner Successfully.',
  UpdatedStatusStorePartnerSuccessfully: 'Updated Store Partner Status Successfully.',
  UpdatedStorePartnerSuccessfully: 'Updated Store Partner Information Successfully.',
  UpdatedStorePartnerStatusSuccessfully: 'Updated Store Partner Status Information Successfully.',

  CreatedCashierSuccessfully: 'Created New Cashier Successfully.',
  UpdatedCashierSuccessfully: 'Updated Cashier Successfully.',
  UpdatedCashierStatusSuccessfully: 'Updated Cashier Status Successfully.',
  DeletedCashierSuccessfully: 'Deleted Cashier Successfully.',
  UpdatedCashierProfileSuccessfully: 'Updated Cashier Profile Successfully.',

  CreatedPartnerProductSuccessfully: 'Created New Partner Product Successfully.',
  UpdatedPartnerProductSuccessfully: 'Updated Partner Product Successfully.',
  DeletedPartnerProductSuccessfully: 'Deleted Partner Product Successfully.',
  UpdatedPartnerProductStatusSuccessfully: 'Updated Partner Product Status Successfully.',

  UpdateOrderSuccessfully: 'Update Order Successfully.',

  UpdatedConfigurationsSuccessfully: 'Updated Configuration Successfully.',

  MoneyExchangeToKitchenCenterSuccessfully: 'Sent Money To Kitchen Center Successfully.',
  WithdrawMoneySuccessfully: 'Withdraw Money To Store Successfully.',
  UpdateSchedulingTimeJob: 'Changed The Time To Automatically Transfer Money Successfully.',
};
